import { useRef, useState } from "react";
import { toast } from "sonner";
import client from "@/lib/api";
import { X, Upload } from "lucide-react";

// Uploads images to /admin/upload (returns base64 webp data URL) and manages a list.
export default function ImageUploader({ images = [], onChange, testid = "image-uploader" }) {
  const [busy, setBusy] = useState(false);
  const [urlInput, setUrlInput] = useState("");
  const fileRef = useRef();

  const upload = async (files) => {
    setBusy(true);
    try {
      const next = [...images];
      for (const file of files) {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await client.post("/admin/upload", fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        next.push(data.url);
      }
      onChange(next);
    } catch (e) {
      toast.error("Upload failed");
    } finally {
      setBusy(false);
    }
  };

  const remove = (i) => onChange(images.filter((_, idx) => idx !== i));
  const addUrl = () => {
    if (urlInput.trim()) {
      onChange([...images, urlInput.trim()]);
      setUrlInput("");
    }
  };

  return (
    <div data-testid={testid}>
      <div className="flex flex-wrap gap-2">
        {images.map((img, i) => (
          <div key={i} className="relative h-20 w-20 overflow-hidden rounded border border-yaza-border">
            <img src={img} alt="" className="h-full w-full object-cover" />
            <button
              type="button"
              onClick={() => remove(i)}
              data-testid={`${testid}-remove-${i}`}
              className="absolute right-0 top-0 bg-black/70 p-0.5 text-white"
            >
              <X size={14} />
            </button>
          </div>
        ))}
        <button
          type="button"
          onClick={() => fileRef.current?.click()}
          data-testid={`${testid}-add`}
          className="flex h-20 w-20 flex-col items-center justify-center gap-1 rounded border border-dashed border-yaza-border text-neutral-500 hover:border-yaza-accent hover:text-yaza-accent"
        >
          <Upload size={16} />
          <span className="text-[10px]">{busy ? "…" : "Upload"}</span>
        </button>
      </div>
      <input
        ref={fileRef}
        type="file"
        accept="image/*"
        multiple
        className="hidden"
        onChange={(e) => e.target.files.length && upload(Array.from(e.target.files))}
      />
      <div className="mt-2 flex gap-2">
        <input
          value={urlInput}
          onChange={(e) => setUrlInput(e.target.value)}
          placeholder="…or paste image URL"
          className="flex-1 rounded border border-yaza-border bg-transparent px-3 py-1.5 text-xs outline-none"
        />
        <button type="button" onClick={addUrl} className="rounded border border-yaza-border px-3 text-xs hover:border-yaza-accent">Add</button>
      </div>
    </div>
  );
}
